import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
query WorkOSLinksFromCode($code: String) {
  workOSLinksFromCode(code: $code) {
    ssoUrl
    directorySyncUrl
  }
}
`

export const workOSLinksFromCodeKey = getQueryNames(query)[0]

export default query
